import z from "zod";
export const SourceMetadataSchema = z.object({
    source_id: z.string().min(1),
    source_type: z.enum([
        "file",
        "jira",
        "confluence",
        "knowledge_base",
        "github",
        "mail",
        "tool",
        "unknown",
    ]),
    source_name: z.string().min(1),
    source_url: z.string().url().optional(),
    updated_at: z.string().optional(),
    uploaded_at: z.string().optional(),
    indexed_at: z.string().optional(),
    version: z.string().optional(),
    status: z.enum(["active", "deprecated", "archive", "unknown"]).optional(),
    freshness_label: z
        .enum(["fresh", "possibly_stale", "stale", "unknown"])
        .optional(),
});
export const SourceMetadataListSchema = z.array(SourceMetadataSchema);
//# sourceMappingURL=source-metadata.schema.js.map